import { gql } from '@apollo/client';

export const GET_CONFIG_FLAGS = gql`
query ConfigFlagsSmallScreenNav {
    config {
      hasSearchMfe: genericType(name: "hasSearchMfe"),
      enableMobileNavRefresh: nonCachedGenericType(name: "enableMobileNavRefresh")
    }
  }
`;

export const GET_SMALL_SCREEN_NAV_BAR_BRAND_LOGO = gql`
  query SmallScreenNavBarBrandLogo($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      brandLogoType
      url
    }
  }
`;

export const GET_SMALL_SCREEN_NAVIGATION_AND_FOOTER_DATA = gql`
  query SmallScreenNavAndFooterData($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      hasSubCategories(hideCategory: false, removeEmptyNames: true)
      navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
        categoryId
        name
        hasSubCategories(displayTypes: ["regular", "clearance", "featured"], expandByDisplayTypes: ["regular"], removeEmptyNames: true)
        navEspotName {
          espotId
          htmlContent
        }
      }
    }
    footer(isDesktop: false){
      footerLogos {
        id
        url
      }
      helpLinks {
        title
        url
        external
        id
      }
      aboutLinks {
        title
        url
        external
        id
      }
      utilityLinks {
        title
        url
        external
        id
      }
      contactUs {
        title
        url
        external
        id
      }
    }
  }
`;
